export default {
      id: "ic_bahista_shines-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_bahista_shines-usage",
      toString: function () {
        return this.url;
      }
    }